import {useNavigate, Link} from "react-router-dom";
import {ReactComponent as SuccessSVG} from '../../../../assets/icons/success.svg';
import {ReactComponent as FailedSVG} from '../../../../assets/icons/failRed.svg';
import {ReactComponent as PendingSVG} from '../../../../assets/icons/pendingYellow.svg';
import {ReactComponent as Warning} from '../../../../assets/icons/warning.svg';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";

const OrderStatus = (props) => {
    const {booking, payment} = props.order;
    const haveTime = props.haveTime;
    const navigate = useNavigate();
    const date = booking.selected_date ? booking.selected_date : false

    dayjs.extend(customParseFormat);
    dayjs.extend(utc)

    const Title = () => {
        return (
            <>
                <div className="title__date">
                    <p className="status-title">{booking?.quotation?.title}</p>
                    {date && (
                        <>
                            {
                                haveTime ? (
                                    <p className="status-selected_date">Fecha
                                        seleccionada:{dayjs.utc(date).format('DD/MM/YY HH:mm').toString()}</p>
                                ) : (
                                    <p className="status-selected_date">Fecha
                                        seleccionada: {dayjs.utc(date).format('DD/MM/YY').toString()}</p>
                                )
                            }
                        </>
                    )}
                    {SelectedOption()}
                </div>

            </>
        )
    }


    const SelectedOption = () => {
        if (booking.selected_option) {
            return (
                <p className={"status-selected_option"}>
                    Opción seleccionada: {booking.selected_option}
                </p>
            )
        }
        return (<></>)
    }

    let htmlByStatus;
    if (booking.status === "completed") {
        htmlByStatus = (
            <>
                <div className="svg-container">
                    <SuccessSVG/>
                </div>
                <h2 className="success">¡Felicitaciones por tu compra!</h2>
                <p className="identifier">
                    Número de reserva: <br/>
                    {booking.order_id}
                </p>
                <Title/>
                <p className="status-message">
                    Estamos seguros de que disfrutarás al máximo de esta nueva aventura. ¡Que tengas un viaje increíble
                    lleno de experiencias inolvidables!
                    <br/>
                    <br/>
                    ¡Buen viaje!
                </p>
                <button
                    onClick={() => navigate("/home")}
                    className="order-status-button"
                >
                    Ir al inicio
                </button>
            </>
        );
    } else if (booking.status === "payment_pending") {
        if (payment.should_show_wire_transfer_data) {
            htmlByStatus = (
                <div className="reservation__extraInfo">
                    <p className="identifier">
                        Número de reserva: <br/>
                        {booking.order_id}
                    </p>
                    <Title/>
                    <p className="reservation-message reservation-message--bold">
                        Tenés <span className="text-primary">24hs</span> para abonar el saldo de ARS
                        ${payment.transaction_pending_amount} y confirmar tu reserva
                    </p>
                    <div className="reservation-message reservation-message__extra-info">
                        <p className="reservation-message__extra-info__title">Instrucciones para pago mediante
                            Transferencia</p>
                        <div className="reservation-message__extra-info__steps">
                            <ol>
                                <li>
                                    Ingresá a tu Homebanking desde tu dispositivo preferido.
                                </li>
                                <li>
                                    Realizá una transferencia de ARS ${payment.transaction_pending_amount} a la
                                    siguiente
                                    cuenta:
                                    <div className="reservation-message__extra-info__info">
                                        <strong>BANCO NACION CUENTA EN PESOS</strong><br/>
                                        Razón social: BUENTOUR SAS<br/>
                                        Nro. de cuenta: CC $ 00460100194728<br/>
                                        CBU: 0110010520001001947282<br/>
                                        Alias: BUENTOUR.PESOS<br/>
                                    </div>
                                </li>
                                <li>
                                    Enviá el comprobante completando éste formulario: <Link target="_blank"
                                                                                            to="https://tally.so/r/nGoBxQ">https://tally.so/r/nGoBxQ</Link>
                                </li>
                                <li>
                                    Una vez que procesemos tu pago, recibirás un email con la confirmación de tu
                                    reserva. <strong>Este proceso puede demorar algunas horas.</strong>
                                </li>
                            </ol>

                        </div>

                    </div>
                    <p className="reservation-message reservation-message--bold reservation-message--warning-title">
                        <span><Warning/></span>
                        No esperes hasta último momento
                    </p>
                    <p className="reservation-message reservation-message--warning">
                        Durante los fines de semana y feriados, los tiempos de procesamiento del pago pueden extenderse,
                        poniendo en riesgo tu lugar en el viaje
                    </p>
                    <button onClick={() => navigate("/home")} className="order-status-button">
                        Entiendo, ir al Inicio
                    </button>
                </div>
            )
        } else if (payment.should_show_bank_transfer_data) {
            htmlByStatus = (
                <div className="reservation__extraInfo">
                    <p className="identifier">
                        Número de reserva: <br/>
                        {booking.order_id}
                    </p>
                    <Title/>
                    <p className="reservation-message reservation-message--bold">
                        Tenés <span className="text-primary">24hs</span> para abonar el saldo de ARS
                        ${payment.transaction_pending_amount} y confirmar tu reserva
                    </p>
                    <div className="reservation-message reservation-message__extra-info">
                        <p className="reservation-message__extra-info__title">Instrucciones para pago mediante
                            Depósito bancario o Efectivo</p>
                        <div className="reservation-message__extra-info__steps">
                            <ol>
                                <li>
                                    Dirigete a la sucursal de tu banco más cercana.
                                </li>
                                <li>
                                    Realizá un depósito de ARS ${payment.transaction_pending_amount} a la siguiente
                                    cuenta:
                                    <div className="reservation-message__extra-info__info">
                                        <strong>BANCO NACION CUENTA EN PESOS</strong><br/>
                                        Razón social: BUENTOUR SAS<br/>
                                        Nro. de cuenta: CC $ 00460100194728<br/>
                                        CBU: 0110010520001001947282<br/>
                                        Alias: BUENTOUR.PESOS<br/>
                                    </div>
                                </li>
                                <li>
                                    Enviá el comprobante completando éste formulario: <Link target="_blank"
                                                                                            to="https://tally.so/r/nGoBxQ">https://tally.so/r/nGoBxQ</Link>
                                </li>
                                <li>
                                    Una vez que procesemos tu pago, recibirás un email con la confirmación de tu
                                    reserva. <strong>Este proceso puede demorar algunas horas.</strong>
                                </li>
                            </ol>

                        </div>

                    </div>
                    <p className="reservation-message reservation-message--bold reservation-message--warning-title">
                        <span><Warning/></span>
                        No esperes hasta último momento
                    </p>
                    <p className="reservation-message reservation-message--warning">
                        Durante los fines de semana y feriados, los tiempos de procesamiento del pago pueden extenderse,
                        poniendo en riesgo tu lugar en el viaje
                    </p>
                    <button onClick={() => navigate("/home")} className="order-status-button">
                        Entiendo, ir al Inicio
                    </button>
                </div>
            )
        } else if (payment.should_show_cash_transfer_data) {
            htmlByStatus = (
                <div className="reservation__extraInfo">
                    <p className="identifier">
                        Número de reserva: <br/>
                        {booking.order_id}
                    </p>
                    <Title/>
                    <p className="reservation-message reservation-message--bold">
                        Tenés <span className="text-primary">24hs</span> para abonar el saldo de ARS
                        ${payment.transaction_pending_amount} y confirmar tu reserva
                    </p>
                    <div className="reservation-message reservation-message__extra-info">
                        <p className="reservation-message__extra-info__title">Instrucciones para pago en Efectivo</p>
                        <div className="reservation-message__extra-info__steps">
                            <ol>
                                <li>
                                    Dirigete a la sucursal de tu banco más cercana.
                                </li>
                                <li>
                                    Realizá un depósito de ARS ${payment.transaction_pending_amount} a la siguiente
                                    cuenta:
                                    <div className="reservation-message__extra-info__info">
                                        <strong>BANCO NACION CUENTA EN PESOS</strong><br/>
                                        Razón social: BUENTOUR SAS<br/>
                                        Nro. de cuenta: CC $ 00460100194728<br/>
                                        CBU: 0110010520001001947282<br/>
                                        Alias: BUENTOUR.PESOS<br/>
                                    </div>
                                </li>
                                <li>
                                    Enviá el comprobante completando éste formulario: <Link target="_blank"
                                                                                            to="https://tally.so/r/nGoBxQ">https://tally.so/r/nGoBxQ</Link>
                                </li>
                                <li>
                                    Una vez que procesemos tu pago, recibirás un email con la confirmación de tu
                                    reserva. <strong>Este proceso puede demorar algunas horas.</strong>
                                </li>
                            </ol>

                        </div>

                    </div>
                    <p className="reservation-message reservation-message--bold reservation-message--warning-title">
                        <span><Warning/></span>
                        No esperes hasta último momento
                    </p>
                    <p className="reservation-message reservation-message--warning">
                        Durante los fines de semana y feriados, los tiempos de procesamiento del pago pueden extenderse,
                        poniendo en riesgo tu lugar en el viaje
                    </p>
                    <button onClick={() => navigate("/home")} className="order-status-button">
                        Entiendo, ir al Inicio
                    </button>
                </div>
            )
        } else if (payment.is_reservation && (payment.status === "PENDING" || payment.status === "AUTHORIZED")) {
            htmlByStatus = (
                <>
                    <div className="svg-container">
                        <SuccessSVG/>
                    </div>
                    <h2 className="success">¡Hemos recibido tu pago!</h2>
                    <p className="identifier">
                        Número de reserva: <br/>
                        {booking.order_id}
                    </p>
                    <Title/>
                    <p className="reservation-message">
                        ¡Has reservado tu lugar en el {booking.quotation.title}!
                    </p>
                    <p className="reservation-message ">
                        Revisa tu bandeja de entrada para los próximos pasos e instrucciones para pagar el saldo
                        restante.
                    </p>
                    <button
                        onClick={() =>
                            navigate(
                                "/home"
                            )
                        }
                        className="order-status-button"
                    >
                        Entiendo, ir al Inicio
                    </button>
                </>
            );
        } else if (payment.status === "PENDING" || payment.status === "AUTHORIZED") {
            htmlByStatus = (
                <>
                    <div className="svg-container">
                        <PendingSVG/>
                    </div>
                    <h2 className="pending">Pago pendiente</h2>
                    <p className="identifier">
                        Número de reserva: <br/>
                        {booking.order_id}
                    </p>
                    <Title/>
                    <p className="status-message">
                        Hemos recibido tu solicitud, pero la operación aún no se ha completado. Te enviaremos un correo
                        electrónico cuando tengamos una resolución.
                    </p>
                    <button
                        onClick={() =>
                            navigate(
                                "/home"
                            )
                        }
                        className="order-status-button"
                    >
                        Entiendo, ir al Inicio
                    </button>
                </>
            );
        } else if (payment.status === "DECLINED") {
            htmlByStatus = (
                <>
                    <div className="svg-container">
                        <FailedSVG/>
                    </div>
                    <h2 className="failed">Hubo un problema con el pago</h2>
                    <p className="identifier">
                        Número de referencia de pago: <br/>
                        {payment.public_id}
                    </p>
                    <Title/>
                    <p className="status-message">
                        Lamentamos informarte que no pudimos procesar tu reserva.
                    </p>
                    <button
                        onClick={() =>
                            navigate(
                                "/checkout/payments?external_reference=" + payment.public_id
                            )
                        }
                        className="order-status-button"
                    >
                        Intentar de nuevo
                    </button>
                </>
            );
        }
    } else if (booking.status === "cancelled") {
        htmlByStatus = (
            <>
                <div className="svg-container">
                    <FailedSVG/>
                </div>
                <h2 className="failed">Hubo un problema con el pago</h2>
                <p className="identifier">
                    Número de referencia de pago: <br/>
                    {payment.public_id}
                </p>
                <Title/>
                <p className="status-message">
                    Lamentamos informarte que no pudimos procesar tu reserva.
                </p>
                <button
                    onClick={() => navigate("/home")}
                    className="order-status-button"
                >
                    Ir al inicio
                </button>
            </>
        );
    }

    return <div className="order-status__container">{htmlByStatus}</div>;
};

export default OrderStatus;
